<template>
  <div class="index-box">
    <el-row :gutter="15">
      <el-col :xs="24" :sm="16" :md="16" :lg="18" :xl="18">
        <div class="card-box">
          <el-row :gutter="15">
            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
              <el-carousel height="260px" class="index-carousel">
                <el-carousel-item v-for="(item, index) in newsImg" :key="index">
                  <div
                    class="index-carousel_link"
                    @click="toServiceUrl(item.url)"
                  >
                    <el-image
                      style="width: 100%; height: 100%"
                      :src="item.src"
                      fit="cover"
                    ></el-image>
                    <div class="index-carousel_title">
                      <span>{{ item.title }}</span>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
              <div style="height: 260px; overflow: hidden">
                <div class="card-box-head">
                  <span class="card-box-title">工作动态</span>
                  <!-- <span class="card-box-more">更多 >></span> -->
                </div>
                <div class="card-box-body">
                  <ul class="news-list">
                    <li
                      class="news-list-item"
                      v-for="(item, index) in newsList"
                      :key="index"
                    >
                      <!--<router-link to="/paperDetail" class="news-list_link" :title="item.title">-->
                      <router-link
                        :to="{
                          name: 'paperDetail',
                          params: {
                            title: item.title,
                            paper: item.paper,
                            paper_title2: item.paper_title2,
                          },
                        }"
                        :title="item.title"
                        class="news-list_link"
                      >
                        <span class="news-list_title">{{ item.title }}</span>
                        <span class="news-list_date">{{ item.date }}</span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" :lg="6" :xl="6">
        <div class="card-box" style="height: 290px">
          <el-image
            style="width: 100%; height: 65px"
            :src="gsxxImg"
            fit="cover"
          ></el-image>
          <div class="card-box-body">
            <div class="info-summary">
              <p v-html="presentation" style="max-height: 285px"></p>
              <router-link
                :to="{
                  name: 'presentationDetail',
                  params: {
                    presentation: presentation,
                    presentation_title: presentation_title,
                    presentation_title2: presentation_title2,
                  },
                }"
                type="primary"
                class="info-summary_more"
              >
                [详情]
              </router-link>
              <!--<el-link href="http://scjg.baotou.gov.cn/tzsbgs.jhtml" target="_blank" type="primary" class="info-summary_more">[更多]</el-link>-->
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 行政许可 -->
    <el-row :gutter="15">
      <el-col :span="24">
        <div class="license-box">
          <div class="license-box_title">行政许可</div>
          <div class="license-list">
            <div
              class="license-list-item"
              v-for="(item, index) in licenseList"
              :key="index"
              @click="toServiceUrl(item.url)"
              :title="item.title"
            >
              <div class="license-list-item_content">
                <el-image
                  style="width: 40px; height: 40px"
                  :src="
                    item.icon
                      ? item.icon
                      : 'data:image/svg+xml;base64,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'
                  "
                  fit="cover"
                ></el-image>
                <span class="license-list-item_title">{{ item.title }}</span>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :xs="24" :sm="16" :md="16" :lg="18" :xl="18">
        <el-row :gutter="15">
          <!-- 服务 -->
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <div class="card-box" style="height: 240px; overflow: hidden">
              <div class="card-box-head">
                <div class="card-box-title">服 务</div>
                <div class="card-box-tabs flex-1">
                  <span
                    class="tabs-label"
                    v-for="(item, index) in tabs1"
                    :key="index"
                    :class="{ active: isActive1(index) }"
                    @mouseenter="changeTab1(item, index)"
                    @click="enterList()"
                  >
                    {{ item.label }}
                  </span>
                </div>
              </div>
              <div class="card-box-body">
                <ul class="news-list" v-show="active1 === 0">
                  <li
                    class="news-list-item"
                    v-for="(item, index) in serviceListJc"
                    :key="index"
                    @click="toServiceUrl(item.url)"
                    :title="item.title"
                  >
                    <span class="news-list_title">{{ item.title }}</span>
                  </li>
                </ul>
                <ul class="news-list" v-show="active1 === 1">
                  <li
                    class="news-list-item"
                    v-for="(item, index) in serviceListSc"
                    :key="index"
                    @click="toServiceUrl(item.url)"
                    :title="item.title"
                  >
                    <span class="news-list_title">{{ item.title }}</span>
                  </li>
                </ul>
                <ul class="news-list" v-show="active1 === 2">
                  <li
                    class="news-list-item"
                    v-for="(item, index) in serviceListSy"
                    :key="index"
                    @click="toServiceUrl(item.url)"
                    :title="item.title"
                  >
                    <span class="news-list_title">{{ item.title }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
          <!-- 特种设备专业知识 -->
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <div class="card-box" style="height: 240px; overflow: hidden">
              <div class="card-box-head">
                <span class="card-box-title">特种设备专业知识</span>
                <!-- <span class="card-box-more">更多 >></span> -->
              </div>
              <div class="card-box-body">
                <ul class="news-list">
                  <li
                    class="news-list-item"
                    v-for="(item, index) in newsList2"
                    :key="index"
                  >
                    <!--<router-link to="/newsDetail" class="news-list_link" :title="item.title">-->
                    <div
                      v-if="item.url ? item.url.trim() : false"
                      class="news-list_link"
                      @click="toServiceUrl(item.url)"
                    >
                      <span class="news-list_title">{{ item.title }}</span>
                      <span class="news-list_date">{{ item.date }}</span>
                    </div>
                    <router-link
                      v-else
                      :to="{
                        name: 'expertiseDetail',
                        params: {
                          presentation: item.show_text,
                          presentation_title: item.show_title,
                          presentation_title2: item.show_title2,
                        },
                      }"
                      :title="item.title"
                      class="news-list_link"
                    >
                      <span class="news-list_title">{{ item.title }}</span>
                      <span class="news-list_date">{{ item.date }}</span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
        </el-row>
        <!-- 法规 -->
        <el-row>
          <div class="card-box" style="height: 240px; overflow: hidden">
            <div class="card-box-head">
              <div class="card-box-title">政策法规</div>
              <div class="card-box-tabs flex-1">
                <span
                  class="tabs-label"
                  v-for="(item, index) in tabs2"
                  :key="index"
                  :class="{ active: isActive2(index) }"
                  @mouseenter="changeTab2(item, index)"
                  @click="enterList()"
                >
                  {{ item.label }}
                </span>
              </div>
            </div>
            <div class="card-box-body">
              <ul class="news-list" v-show="active2 === 0">
                <li
                  class="news-list-item"
                  v-for="(item, index) in policyList1"
                  :key="index"
                >
                  <!--<router-link to="/newsDetail" class="news-list_link" :title="item.title">-->
                  <div
                    v-if="item.url ? item.url.trim() : false"
                    class="news-list_link"
                    @click="toServiceUrl(item.url)"
                  >
                    <span class="news-list_title">{{ item.title }}</span>
                    <span class="news-list_date">{{ item.date }}</span>
                  </div>
                  <router-link
                    v-else
                    :to="{
                      name: 'lawDetail',
                      params: {
                        presentation: item.show_text,
                        presentation_title: item.show_title,
                        presentation_title2: item.show_title2,
                      },
                    }"
                    :title="item.title"
                    class="news-list_link"
                  >
                    <span class="news-list_title">{{ item.title }}</span>
                    <span class="news-list_date">{{ item.date }}</span>
                  </router-link>
                </li>
              </ul>
              <ul class="news-list" v-show="active2 === 1">
                <li
                  class="news-list-item"
                  v-for="(item, index) in policyList2"
                  :key="index"
                >
                  <!--<router-link to="/newsDetail" class="news-list_link" :title="item.title">-->
                  <div
                    v-if="item.url ? item.url.trim() : false"
                    class="news-list_link"
                    @click="toServiceUrl(item.url)"
                  >
                    <span class="news-list_title">{{ item.title }}</span>
                    <span class="news-list_date">{{ item.date }}</span>
                  </div>
                  <router-link
                    v-else
                    :to="{
                      name: 'lawDetail',
                      params: {
                        presentation: item.show_text,
                        presentation_title: item.show_title,
                        presentation_title2: item.show_title2,
                      },
                    }"
                    :title="item.title"
                    class="news-list_link"
                  >
                    <span class="news-list_title">{{ item.title }}</span>
                    <span class="news-list_date">{{ item.date }}</span>
                  </router-link>
                </li>
              </ul>
              <ul class="news-list" v-show="active2 === 2">
                <li
                  class="news-list-item"
                  v-for="(item, index) in policyList3"
                  :key="index"
                >
                  <!--<router-link to="/newsDetail" class="news-list_link" :title="item.title">-->
                  <div
                    v-if="item.url ? item.url.trim() : false"
                    class="news-list_link"
                    @click="toServiceUrl(item.url)"
                  >
                    <span class="news-list_title">{{ item.title }}</span>
                    <span class="news-list_date">{{ item.date }}</span>
                  </div>
                  <router-link
                    v-else
                    :to="{
                      name: 'lawDetail',
                      params: {
                        presentation: item.show_text,
                        presentation_title: item.show_title,
                        presentation_title2: item.show_title2,
                      },
                    }"
                    :title="item.title"
                    class="news-list_link"
                  >
                    <span class="news-list_title">{{ item.title }}</span>
                    <span class="news-list_date">{{ item.date }}</span>
                  </router-link>
                </li>
              </ul>
              <ul class="news-list" v-show="active2 === 3">
                <li
                  class="news-list-item"
                  v-for="(item, index) in policyList4"
                  :key="index"
                >
                  <!--<router-link to="/newsDetail" class="news-list_link" :title="item.title">-->
                  <div
                    v-if="item.url ? item.url.trim() : false"
                    class="news-list_link"
                    @click="toServiceUrl(item.url)"
                  >
                    <span class="news-list_title">{{ item.title }}</span>
                    <span class="news-list_date">{{ item.date }}</span>
                  </div>
                  <router-link
                    v-else
                    :to="{
                      name: 'lawDetail',
                      params: {
                        presentation: item.show_text,
                        presentation_title: item.show_title,
                        presentation_title2: item.show_title2,
                      },
                    }"
                    :title="item.title"
                    class="news-list_link"
                  >
                    <span class="news-list_title">{{ item.title }}</span>
                    <span class="news-list_date">{{ item.date }}</span>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </el-row>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" :lg="6" :xl="6">
        <!-- 查询服务 -->
        <div class="card-box" style="height: 240px; overflow: hidden">
          <el-image
            style="width: 100%; height: 65px"
            :src="cxfwImg"
            fit="cover"
          ></el-image>
          <div class="search-list">
            <el-row :gutter="10">
              <el-col
                :span="12"
                v-for="(item, index) in searchList"
                :key="index"
              >
                <div
                  class="search-list_item"
                  @click="toServiceUrl(item.url)"
                  :title="item.title"
                >
                  {{ item.title }}
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <!-- 投诉举报 -->
        <div class="card-box" style="overflow: hidden">
          <el-image
            style="
              width: 100%;
              height: 150px;
              cursor: pointer;
              border-radius: 10px;
            "
            :src="tsjbImg"
            fit="cover"
          ></el-image>
        </div>
      </el-col>
    </el-row>
    <!-- APP下载 -->
    <el-row :gutter="15">
      <el-col :span="24">
        <div class="card-box">
          <div class="card-box-head">
            <span class="card-box-title">APP下载</span>
          </div>
          <div class="card-box-body">
            <div class="app-list">
              <div
                class="app-list-item"
                v-for="(item, index) in appList"
                :key="index"
              >
                <div class="app-list-item_content">
                  <el-image
                    style="width: 120px; height: 120px"
                    :src="item.appimg"
                    fit="cover"
                  ></el-image>
                  <span class="app-list-item_title">{{ item.title }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 友情链接 -->
    <el-row :gutter="15">
      <el-col :span="24">
        <div class="card-box">
          <div class="web-footer-link">
            <div class="web-footer-link_title">友情链接：</div>
            <div class="web-footer-link_content">
              <el-link
                :href="item.url"
                target="_blank"
                v-for="(item, index) in footerLink"
                :key="index"
                :title="item.title"
              >
                {{ item.title }}
              </el-link>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "合肥市市场监督管理局",
  data() {
    return {
      presentation: "",
      presentation_title: "",
      presentation_title2: "",
      newsImg: [
        {
          src: require("../images/news1.jpg"),
          title:
            "东北三省一区食品检验机构技能比武决赛暨检验检测区域合作交流活动在包举办",
          url: "http://scjg.baotou.gov.cn/xwdt/gzdt/202512/t20251212_718150.html",
        },
        {
          src: require("../images/news2.jpg"),
          title: "摘金夺优！包头市在全区市场监管系统论文决赛中获佳绩",
          url: "http://scjg.baotou.gov.cn/xwdt/gzdt/202512/t20251211_717908.html",
        },
        {
          src: require("../images/news3.jpg"),
          title: "包头市市场监管局专项行动护新国标落地",
          url: "http://scjg.baotou.gov.cn/xwdt/gzdt/202512/t20251204_716539.html",
        },
        {
          src: require("../images/news4.jpg"),
          title: "包头市市场监管局在全区优秀行政处罚案例评选中包揽一、二等奖",
          url: "http://scjg.baotou.gov.cn/xwdt/gzdt/202512/t20251202_716167.html",
        },
        {
          src: require("../images/news5.jpg"),
          title: "包头市市场监管局优秀党务工作者领誓，引领企业党员初心闪亮",
          url: "http://scjg.baotou.gov.cn/xwdt/gzdt/202511/t20251119_713744.html",
        },
      ],
      licenseList: [
        {
          icon: require("../images/icon01.svg"),
          title: "生产（安装、改造、修理）单位许可",
          url: "http://sepsclient.cnse.samr.gov.cn/",
        },
        {
          icon: require("../images/icon01.svg"),
          title: "移动式压力容器和气瓶充装许可",
          url: "https://psp.e-cqs.cn/casServer/login?service=https://xksb.cnse.e-cqs.cn/adm-lic-psp/callback?client_name=cas&code=90000&tacsaccess=1&flag=false",
        },
        {
          icon: require("../images/icon01.svg"),
          title: "管理和作业人员资格认定",
          url: "https://nmexam.tsryks.com:7001/index.shtml",
        },
        {
          icon: require("../images/icon01.svg"),
          title: "特种设备使用登记",
          url: "https://tzsb.bttjs.org.cn/sy/admin/login",
        },
        {
          icon: require("../images/icon01.svg"),
          title: "特种设备检验检测机构核准",
          url: "http://sepsclient.cnse.samr.gov.cn/",
        },
        {
          icon: require("../images/icon01.svg"),
          title: "特种设备检验检测人员资格认定",
          url: "http://sepsclient.cnse.samr.gov.cn/",
        },
      ],
      newsList: [
        {
          title: "包头市市场监管局组织召开全市电梯维保单位等级评定动员会议",
          date: "2023-12-10",
          href: "",
        },
        {
          title:
            "我市出台《包头市产品、工程和服务质量提升行动方案（2023—2025年）》",
          date: "2023-12-07",
          href: "",
        },
        {
          title:
            "包头市召开质量强市活动领导小组工作会议推进盟市政府质量考核等工作",
          date: "2023-12-05",
          href: "",
        },
        {
          title: "我市企业上榜国家智能制造标准应用试点项目",
          date: "2023-12-04",
          href: "",
        },
        {
          title: "包头市市场监管局召开建设全国统一大市场重点工作调度会",
          date: "2023-12-01",
          href: "",
        },
        {
          title:
            "喜报！包头3个市场监督管理所被评定为全国首批五星市场监督管理所",
          date: "2023-11-28",
          href: "",
        },
      ],
      licenseList: [
        {
          icon: require("../images/icon01.svg"),
          title: "生产（安装、改造、修理）单位许可",
          url: "http://sepsclient.cnse.samr.gov.cn/",
        },
        {
          icon: require("../images/icon01.svg"),
          title: "移动式压力容器和气瓶充装许可",
          url: "https://psp.e-cqs.cn/casServer/login?service=https://xksb.cnse.e-cqs.cn/adm-lic-psp/callback?client_name=cas&code=90000&tacsaccess=1&flag=false",
        },
        {
          icon: require("../images/icon01.svg"),
          title: "管理和作业人员资格认定",
          url: "http://110.16.70.23:7001/bm.shtml",
        },
        {
          icon: require("../images/icon01.svg"),
          title: "特种设备使用登记",
          url: "https://tzsb.bttjs.org.cn/sy/admin/login",
        },
        {
          icon: require("../images/icon01.svg"),
          title: "特种设备检验检测机构核准",
          url: "http://sepsclient.cnse.samr.gov.cn/",
        },
        {
          icon: require("../images/icon01.svg"),
          title: "特种设备检验检测人员资格认定",
          url: "http://sepsclient.cnse.samr.gov.cn/",
        },
      ],
      serviceListJc: [
        {
          title: "内蒙古自治区特种设备信息化平台",
          url: "http://tzsb.bttjs.org.cn/index.html",
        },
        {
          title: "包头市气瓶质量安全追溯系统",
          url: "http://nmgbt.ts-tac.cn/samr/#/Login?redirect=%2FIndustryCylinder%2FDocQuery",
        },
        {
          title: "车用气瓶电子标签监管系统",
          url: "http://111.56.38.173:6080/cng2/",
        },
        {
          title: "包头市电梯应急处置服务平台",
          url: "https://www.btdtjy.com:8067",
        }
      ],
      serviceListSc: [
        {
          title: "特种设备施工告知",
          url: "https://tzsb.bttjs.org.cn/sc/admin/login",
        },
        {
          title: "特种设备安装改造修理监督检验申请",
          url: "https://tzsb.bttjs.org.cn/sc/admin/login",
        },
      ],
      serviceListSy: [
        {
          title: "特种设备使用登记",
          url: "https://tzsb.bttjs.org.cn/sy/admin/login",
        },
        {
          title: "特种设备定期检验申请",
          url: "https://tzsb.bttjs.org.cn/sy/admin/login",
        },
        {
          title: "特种设备使用登记变更",
          url: "https://tzsb.bttjs.org.cn/sy/admin/login",
        },
        {
          title: "特种设备检验检测延期申请",
          url: "https://tzsb.bttjs.org.cn/sy/admin/login",
        },
      ],
      tabs1: [
        {
          label: "监察机构",
          value: 0,
        },
        {
          label: "生产单位",
          value: 1,
        },
        {
          label: "使用单位",
          value: 2,
        },
      ],
      active1: 0,
      tabs2: [
        {
          label: "法律法规",
          value: 0,
        },
        {
          label: "安全技术规范",
          value: 1,
        },
        {
          label: "规范性文件",
          value: 2,
        },
        {
          label: "地方法规",
          value: 3,
        },
      ],
      active2: 0,
      policyList1: [
        {
          title: "特种设备安全监督检查办法（国家市场监督管理总局第57号令）",
          date: "2022-05-25",
        },
        {
          title:
            "特种设备事故报告和调查处理规定（国家市场监督管理总局第50号令）",
          date: "2022-01-28",
        },
        {
          title: "特种设备作业人员监督管理办法（国家质检总局第140号令）",
          date: "2021-06-25",
        },
        {
          title: "大型游乐设施安全监察规定（国家质检总局第154号令）",
          date: "2021-04-22",
        },
        {
          title: "客运索道安全监督管理规定（国家质检总局第179号令）",
          date: "2020-11-03",
        },
      ],
      policyList2: [
        {
          title: "压力管道元件型式试验规则（TSG D7002—2023）",
          date: "2023-07-14",
        },
        {
          title: "电梯自行检测规则(TSG T7008-2023)",
          date: "2023-04-07",
        },
        {
          title: "电梯监督检验和定期检验规则(TSG T7001-2023)",
          date: "2023-04-07",
        },
        {
          title: "压力管道定期检验规则—长输管道（TSG D7003—2022）",
          date: "2022-12-30",
        },
        {
          title: "特种设备检验人员考核规则（TSG Z8002-2022）",
          date: "2022-08-05",
        },
      ],
      policyList3: [
        {
          title:
            "市场监管总局办公厅关于加快推进全国气瓶质量安全追溯体系建设的通知（市监特设〔2019〕69号）",
          date: "2019-12-09",
        },
        {
          title:
            "市场监管总局办公厅关于特种设备行政许可有关事项的实施意见（市监特设〔2019〕32号）",
          date: "2019-05-27",
        },
        {
          title:
            "市场监管总局关于特种设备行政许可优化准入服务和加强事中事后监管措施的公告（2019年第8号）",
          date: "2019-02-18",
        },
        {
          title:
            "市场监管总局办公厅关于规范压力容器安全技术有关要求的通知（市监特设函〔2019〕195号）",
          date: "2019-01-29",
        },
        {
          title:
            "市场监管总局关于特种设备行政许可有关事项的公告（2019年第3号）",
          date: "2019-01-16",
        },
      ],
      policyList4: [
        {
          title:
            "包头市市场监督管理局（知识产权局） 关于申报2021、2022年度第三批 知识产权奖励项目的通知",
          date: "2023-11-02",
        },
        {
          title: "包头市市场监督管理局关于印发 开展市场主体除名试点工作的通知",
          date: "2023-09-28",
        },
        {
          title:
            "关于印发《包头市推动知识产权高质量发展年度工作方案（2023）》的通知",
          date: "2023-09-28",
        },
        {
          title:
            "包头市市场监督管理局（知识产权局）关于印发《包头市中小微企业知识产权托管工作方案》的通知",
          date: "2023-09-27",
        },
        {
          title:
            "包头市市场监督管理局（知识产权局）关于运用区块链技术加强数据知识产权保护工作的通知",
          date: "2023-09-26",
        },
      ],
      newsList1: [
        {
          title: "包头市市场监管局组织召开全市电梯维保单位等级评定动员会议",
          date: "2023-12-10",
          href: "",
        },
        {
          title:
            "我市出台《包头市产品、工程和服务质量提升行动方案（2023—2025年）》",
          date: "2023-12-07",
          href: "",
        },
        {
          title:
            "包头市召开质量强市活动领导小组工作会议推进盟市政府质量考核等工作",
          date: "2023-12-05",
          href: "",
        },
        {
          title: "我市企业上榜国家智能制造标准应用试点项目",
          date: "2023-12-04",
          href: "",
        },
        {
          title: "包头市市场监管局召开建设全国统一大市场重点工作调度会",
          date: "2023-12-01",
          href: "",
        },
      ],
      newsList2: [
        {
          title: "包头市市场监管局组织召开全市电梯维保单位等级评定动员会议",
          date: "2023-12-10",
          href: "",
        },
        {
          title:
            "我市出台《包头市产品、工程和服务质量提升行动方案（2023—2025年）》",
          date: "2023-12-07",
          href: "",
        },
        {
          title:
            "包头市召开质量强市活动领导小组工作会议推进盟市政府质量考核等工作",
          date: "2023-12-05",
          href: "",
        },
        {
          title: "我市企业上榜国家智能制造标准应用试点项目",
          date: "2023-12-04",
          href: "",
        },
        {
          title: "包头市市场监管局召开建设全国统一大市场重点工作调度会",
          date: "2023-12-01",
          href: "",
        },
      ],
      searchList: [
        {
          title: "单位人员资质查询",
          url: "https://cnse.e-cqs.cn/info-pub/pub",
        },
        {
          title: "标准查询下载",
          url: "https://std.samr.gov.cn/",
        },
        {
          title: "包头梯梯平台",
          url: "http://baotou.titi365.com",
        },
      ],
      appList: [
        {
          appimg: require("../images/app1.png"),
          title: "特种设备信息化平台移动端",
        },
        {
          appimg: require("../images/app2.png"),
          title: "查安康”风控平台手机APP",
        },
        {
          appimg: require("../images/app3.png"),
          title: "包头市电梯应急处置服务平台APP",
        },
        {
          appimg: require("../images/app4.png"),
          title: "特种设备现场监督检查手机APP",
        },
        {
          appimg: require("../images/app1.png"),
          title: "无纸化维保手机APP",
        },
      ],
      cxfwImg: require("../images/img_cxfw.png"),
      gsxxImg: require("../images/img_gsxx.png"),
      tsjbImg: require("../images/img_tsjb.jpg"),
      footerLink: [
        {
          title: "国家市场监管总局",
          url: "https://www.samr.gov.cn/",
        },
        {
          title: "国家市场监管总局特种设备安全监察局",
          url: "https://www.samr.gov.cn/tzsbj/",
        },
        {
          title: "自治区市场监管局",
          url: "http://amr.nmg.gov.cn/",
        },
        {
          title: "包头市市场监管局",
          url: "http://scjg.baotou.gov.cn/",
        },
        {
          title: "自治区特检院",
          url: "http://www.nmgtjy.cn/",
        },
        {
          title: "自治区特检院包头分院",
          url: "http://www.nmgtjy.cn/fy_81/",
        },
      ],
    };
  },

  methods: {
    getJobItemList() {
      this.listLoading = true; //发起请求之前显示加载条
      //发起请求获取数据
      this.$axios
        .post(
          "http://baotou.titi365.com/server/nqi_baotou/getJobData",
          this.query
        )
        // this.$axios.post("/api/nqi_baotou/getJobData",this.query)
        .then((result) => {
          console.log(result.data);
          result = result.data;
          if (result.msg) {
            this.newsList = result.data.newsList;
            // 对newsList按照时间排序
            if (this.newsList && this.newsList.length > 0) {
              this.newsList.sort((a, b) => {
                // 方式1：降序
                return new Date(b.date) - new Date(a.date);
              });
            }
          } else {
            this.$message({
              message: "获取数据失败！" + result.msg,
              type: "error",
            });
          }
          this.listLoading = false;
        })
        .catch((result) => {
          this.$message({
            message: "系统错误！",
            type: "error",
          });
        });
    },

    getItemList() {
      this.listLoading = true; //发起请求之前显示加载条
      //发起请求获取数据
      console.log(this.query);
      this.$axios
        .post("http://baotou.titi365.com/server/nqi_baotou/getData", this.query)
        // this.$axios.post("/api/nqi_baotou/getData",this.query)
        .then((result) => {
          // console.log(result);
          result = result.data;
          if (result.msg) {
            this.licenseList = [
              ...this.licenseList,
              ...result.data.licenseList,
            ];
            this.serviceListJc = [
              ...this.serviceListJc,
              ...result.data.serviceListJc,
            ];
            this.serviceListSc = [
              ...this.serviceListSc,
              ...result.data.serviceListSc,
            ];
            this.serviceListSy = [
              ...this.serviceListSy,
              ...result.data.serviceListSy,
            ];
            this.policyList1 = result.data.policyList1;
            //this.policyList2 = [...this.policyList2,...result.data.policyList2];
            this.policyList2 = result.data.policyList2;
            this.policyList3 = result.data.policyList3;
            //this.policyList4 = [...this.policyList4,...result.data.policyList4];
            this.policyList4 = result.data.policyList4;
            this.newsList1 = [...this.newsList1, ...result.data.newsList1];
            //this.newsList2 = [...this.newsList2,...result.data.newsList2];
            this.newsList2 = result.data.newsList2;

            console.log(this.newsList2);
            this.appList = [...this.appList, ...result.data.appList];
            this.presentation = result.data.presentation;
            this.presentation_title = result.data.presentation_title;
            this.presentation_title2 = result.data.presentation_title2;
          } else {
            this.$message({
              message: "获取数据失败！" + result.msg,
              type: "error",
            });
          }
          this.listLoading = false;
        })
        .catch((result) => {
          this.$message({
            message: "系统错误！",
            type: "error",
          });
        });
    },

    newsImgCon() {
      this.$router.push({
        path: item.href,
      });
    },
    enterList() {
      console.log("列表");
      // this.$router.push({
      //   path: "/newsList",
      // });
    },
    toServiceUrl(url) {
      window.open(url, "_blank");
    },
    changeTab1(item, index) {
      this.active1 = index;
    },
    changeTab2(item, index) {
      this.active2 = index;
    },
  },
  computed: {
    isActive1() {
      return (index) => {
        return this.active1 === index;
      };
    },
    isActive2() {
      return (index) => {
        return this.active2 === index;
      };
    },
  },
  mounted() {
    this.getItemList();
    this.getJobItemList();
  },
};
</script>

<style scoped>
/* 公示信息 style start */
.info-summary {
  position: relative;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.info-summary p {
  text-indent: 2rem;
  line-height: 28px;
  color: #333333;
}
.info-summary_more {
  position: absolute;
  right: 5px;
  bottom: 7px;
}
/* 公示信息 style end */

/* 友情链接 style start */
.web-footer-link {
  display: flex;
}
.web-footer-link_title {
  color: #1369c1;
  font-weight: 700;
}
.web-footer-link_content {
  flex: 1;
}
.web-footer-link_content a {
  padding: 0 10px;
}
/* 友情链接 style end */
</style>



// WEBPACK FOOTER //
// src/components/index.vue